import React from 'react'
import Hero from '../../components/hero/Hero'
import PagesChecklist from '../../components/pages/PagesChecklist'
import './Analitica.css'
import ButtonMain from '../../components/ButtonMain'


function Analitica() {
    return (
        <div className="analiticaWrapper">
            <Hero style={{backgroundColor:"white!important"}}
            title="Analitica."
            title2="Descubre y visualiza datos en Google Data Studio"
            sub="Entiendo mejor tu negocio y a tus clientes. Desde Gooogle Data Studio podrás visualzar y reunir la información de varios canales, fuentes y redes."
         
            />
            <PagesChecklist
                subtitle="Creamos valor para tu negocio en internet."
                checklist1="Descubre, procesa y decide en base a datos."
                checklist2="Controla el gasto y retorno de tu inversión."
                checklist3="Consigue nuevos clientes y verbaliza tu marca."
                checklist4="Transforma tu negocio y compite en internet."
            />
            <div style={{height:"90px"}}/>
            <PagesChecklist
                subtitle="Canalaes y modelos de publicidad que gestionamos."
                checklist1="Google Ads, tu negocio en las primeras posiciones."
                checklist2="Google Display Network, visibilidad en emplazamientos."
                checklist3="Google Shopping, tus productos arriba."
                checklist4="Google Partners, aparece en otros buscadores."
            />
            <div style={{marginLeft:"10vw"}}>
            <ButtonMain mainbtn="¿Nos conectamos?"/>
            </div>
        </div>
    )
}

export default Analitica
